export default {
  contained: {
    '&:disabled': {
      color: '#fff',
      backgroundColor: '#A5B8D8',
    },
  },
  outlined: {
    '&:disabled': {
      color: '#A5B8D8',
    },
  },
  text: {
    '&:disabled': {
      color: '#A5B8D8',
    },
  },
};
